

























import Vue from "vue";

export default Vue.extend({
  name: "BaseInput",
  data() {
    return {
      oldValue: "",
      currentValue: "",
    };
  },
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    hint: {
      type: String,
    },
    label: {
      type: String,
    },
    type: {
      type: String,
    },
    isReactive: {
      type: Boolean,
      default: false,
    },
    isfloat: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    needStringFilter: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    if (this.$props.autofocus) {
      this.$refs.input.focus();
      //this.oldValue = this.value;
      this.currentValue = this.value;
    }
  },
  methods: {
    updateSelf(value: string) {
      if (this.isReactive) {
        let toReturn = this.getCorrectValue(value);
        //this.oldValue = toReturn;
        this.currentValue = toReturn;
        this.$emit("input", toReturn);
      } else {
        this.currentValue = value;
      }
    },
    getCorrectValue(value: string) {
      let toReturn: string | number = value;
      if (this.$props.type === "number") {
        toReturn = this.isfloat ? parseFloat(toReturn) : parseInt(toReturn);
        if (!toReturn || isNaN(<number>toReturn)) {
          toReturn = 0;
        }
        if (this.$props.min && toReturn < this.$props.min) {
          toReturn = this.$props.min;
        }
        if (this.$props.max && toReturn > this.$props.max) {
          toReturn = this.$props.max;
        }
        //Округление до двух знаков после запятой
        if (this.isfloat) {
          toReturn = Math.floor(<number>toReturn * 100) / 100;
        }
      } else {
        if (this.needStringFilter) {
          toReturn = toReturn.toString().replace(/[\*\:"\|>\?<\/\\~]/g, "");
        }
      }

      if (this.limit !== null) {
        toReturn = toReturn.toString().slice(0, this.limit);
      }

      (<HTMLInputElement>this.$refs.input).value = toReturn.toString();
      return toReturn;
    },
    blur() {
      this.$refs.input.blur();
    },
    onBlur() {
      /* if (this.currentValue === "") {
        this.$emit("input", this.oldValue);
        this.currentValue = this.oldValue;
	  } else { */
      if (!this.isReactive) {
        this.currentValue = this.getCorrectValue(this.currentValue);
        this.$emit("input", this.currentValue);
      }
      this.$emit("blur");
      //this.oldValue = this.currentValue;
      //}
    },
  },
});
